import { useWatch } from 'react-hook-form';

import { useFeePolicy } from 'reservations/account/providers/ConfigProvider';
import { FeeCollectTypeEnum } from 'reservations/booking/types';

/**
 * Returns whether a cancellation fee applies to the booking according to the restaurant's current policy.
 *
 * Criteria for being subject to a cancellation fee:
 * - the restaurant has enabled a booking cancellation policy,
 * - AND the policy is set to collect a fee,
 * - AND the fee collection type is CardOnFile,
 * - AND the party size of the booking is greater than or equal to the policy's minimum party size
 *
 * @returns {boolean} whether or not the current booking would be subject to a cancellation fee
 */
export const useIsSubjectToCancellationFee = () => {
  const { collectType, minPartySize, shouldCollect } = useFeePolicy();
  const [bookingType, partySize] = useWatch({
    name: ['bookingType', 'partySize']
  });

  const isFeeRuleEnabled = shouldCollect;
  const isFeeCollectTypeCardOnFile =
    collectType === FeeCollectTypeEnum.enum.CardOnFile;
  const doesPartySizeMeetFeeCriteria =
    !isNaN(partySize) && partySize >= minPartySize;

  const isReservation = bookingType === 'Reservation';

  return (
    isFeeRuleEnabled &&
    isFeeCollectTypeCardOnFile &&
    doesPartySizeMeetFeeCriteria &&
    isReservation
  );
};
